/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { DateInputRow } from '../../../../../javascript/shared/components/form';
import * as Utilities from '../utilities';
import { FormHeader } from '../../react/form_header.jsx';
import { FormThemeContext } from '../../react/form_theme_context.js.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';

import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from '../store/actions';
import { FormRow } from '../../react/form_row.jsx';
import { AttendeeQuestionChoiceList } from './attendee_question_choice_list.jsx';

export class AttendeeQuestionForm extends React.Component {
  static contextType = FormThemeContext;

  static propTypes = {
    question: Actions.AttendeeQuestionShape,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onChoiceAdd: PropTypes.func,
    onChoiceChange: PropTypes.func,
    onChoiceDragStart: PropTypes.func,
    onChoiceDragUpdate: PropTypes.func,
    onChoiceDragFinish: PropTypes.func,
    onChoiceDragCancel: PropTypes.func
  };

  constructor(...args) {
    super(...args);
    this.onReponseTypeChange = this.onReponseTypeChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.inputChanged = this.inputChanged.bind(this);
    this.dateInputChanged = this.dateInputChanged.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onChoiceChange = this.onChoiceChange.bind(this);
    this.onChoiceAdd = this.onChoiceAdd.bind(this);
    this.onChoiceDelete = this.onChoiceDelete.bind(this);
    this.onChoiceDragStart = this.onChoiceDragStart.bind(this);
    this.onChoiceDragUpdate = this.onChoiceDragUpdate.bind(this);
    this.onChoiceDragFinish = this.onChoiceDragFinish.bind(this);
    this.onChoiceDragCancel = this.onChoiceDragCancel.bind(this);
  }

  onReponseTypeChange(event) {
          if ((event.target.value === "dropdown") && (this.props.question.choices.length === 0)) {
            if (typeof this.props.onChoiceAdd === 'function') {
              this.props.onChoiceAdd(this.props.question.id);
            }
          }
          return this.onInputChange(event);
        }

        onInputChange(event, name, value) {
          const field_name = (name != null) ? name : event.target.name;
          const field_value = (value != null) ? value : event.target.type === 'checkbox' ? event.target.checked : event.target.value;
          return (typeof this.props.onChange === 'function' ? this.props.onChange(field_name, field_value, event) : undefined);
        }

        // Returns a callback function to call onInputChange with the specified name
        inputChanged(name) {
          return event => this.onInputChange(event, name);
        }

        dateInputChanged(event, value, input_value) {
          let new_value;
          if (value === 'blank') {
            new_value = '';
          } else if (value !== 'error') {
            new_value = value.toString('yyyy-MM-dd');
          }

          return this.onInputChange(event, event.target.name, new_value);
        }

        isValid() {
          if (this.props.question.question.isBlank()) { return false; }
          return true;
        }

        onChoiceChange(index, event) {
          const question_id = this.props.question.id;
          const {
            value
          } = event.target;
          return (typeof this.props.onChoiceChange === 'function' ? this.props.onChoiceChange(question_id, index, value, event) : undefined);
        }

        onChoiceAdd(event) {
          return (typeof this.props.onChoiceAdd === 'function' ? this.props.onChoiceAdd(this.props.question.id, event) : undefined);
        }

        onChoiceDelete(index) {
          return (typeof this.props.onChoiceDelete === 'function' ? this.props.onChoiceDelete(this.props.question.id, index) : undefined);
        }

        onChoiceDragStart(item) {
          return (typeof this.props.onChoiceDragStart === 'function' ? this.props.onChoiceDragStart(this.props.question.id, item) : undefined);
        }

        onChoiceDragUpdate(item, index) {
          return (typeof this.props.onChoiceDragUpdate === 'function' ? this.props.onChoiceDragUpdate(this.props.question.id, item, index) : undefined);
        }

        onChoiceDragFinish(result, item) {
          return (typeof this.props.onChoiceDragFinish === 'function' ? this.props.onChoiceDragFinish(this.props.question.id, item, result) : undefined);
        }

        onChoiceDragCancel(item) {
          return (typeof this.props.onChoiceDragCancel === 'function' ? this.props.onChoiceDragCancel(this.props.question.id, item) : undefined);
        }

        render() {
          const wants_choice_list = this.props.question.response_type === 'dropdown';

          const id_prefix = `attendee-question-${this.props.question.id}`;

          return <tr>
            <td className="edit-form" colSpan="5">
              <FormInputGroup>
                <FormRow title="Question"
                         labelFor={`${id_prefix  }-question`}
                         {...this.context.textInputRow}
                         required>
                  <input name="question"
                         type="text"
                         id={`${id_prefix  }-question`}
                         className={this.context.textInputRow.inputClassName}
                         value={this.props.question.question}
                         onChange={this.onInputChange}
                         autoFocus />
                </FormRow>

                <FormRow title="Require Response"
                         tooltip="User must answer this to register successfully"
                         labelFor={`${id_prefix  }-required`}
                         {...this.context.checkboxRow}>
                  <input name="required"
                         type="checkbox"
                         id={`${id_prefix  }-required`}
                         className={this.context.checkboxRow.inputClassName}
                         checked={this.props.question.required}
                         onChange={this.onInputChange} />
                </FormRow>

                <FormRow title="Question Type"
                         labelFor={`${id_prefix  }-response_type`}
                         {...this.context.selectInputRow}>
                  <select name="response_type"
                          id={`${id_prefix  }-response_type`}
                          className={this.context.selectInputRow.inputClassName}
                          value={this.props.question.response_type}
                          onChange={this.onReponseTypeChange}>
                    <option value="string">Short Answer</option>
                    <option value="dropdown">Multiple Choice</option>
                  </select>
                </FormRow>

                {wants_choice_list && <AttendeeQuestionChoiceList questionId={this.props.question.id}
                                                                  choices={this.props.question.choices}
                                                                  onAdd={this.onChoiceAdd}
                                                                  onChange={this.onChoiceChange}
                                                                  onDelete={this.onChoiceDelete}
                                                                  onDragStart={this.onChoiceDragStart}
                                                                  onDragUpdate={this.onChoiceDragUpdate}
                                                                  onDragFinish={this.onChoiceDragFinish}
                                                                  onDragCancel={this.onChoiceDragCancel}/>}

              </FormInputGroup>

              <div className="action-button pull-right">
                <button className="btn-color"
                        disabled={!this.isValid()}
                        onClick={this.props.onClose}>
                  Update Question
                </button>
              </div>
            </td>
          </tr>;
        }
}
